



import Vue from 'vue'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import TileLayer from 'ol/layer/Tile'
import TileWMS from 'ol/source/TileWMS'
import Map from 'ol/Map'
import View from 'ol/View'
import OSM from 'ol/source/OSM'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import Icon from 'ol/style/Icon'
import Style from 'ol/style/Style'
import { fromLonLat, transform } from 'ol/proj'
import {
    TIPOLOGIA_ALTRO,
    TIPOLOGIA_ANIMALI,
    TIPOLOGIA_ACQUEDOTTO_E_FOGNATURE,
    TIPOLOGIA_ARREDO_URBANO,
    TIPOLOGIA_BUCHE,
    TIPOLOGIA_CARTELLONISTICA_PUBBLICITARIA,
    TIPOLOGIA_DANNI_ESTESI_AL_MANTO,
    TIPOLOGIA_ILLUMINAZIONE_E_SEMAFORI,
    TIPOLOGIA_MARCIAPIEDE,
    TIPOLOGIA_SEGNALETICA_E_VIABILITA,
    TIPOLOGIA_RIFIUTI,
    TIPOLOGIA_VERDE,
    STATO_CHIUSA
} from '../../costanti_report'
import { OPEN_LAYER_GEOJSON_FORMAT } from '../../costanti'
// Costanti per la configurazione
const coordinateIniziali = [12.22, 44.69]
const zoomIniziale = 12
export default Vue.extend({
    data: () => ({
        map: null,
        vectorLayerRilevamenti: null,
        styleCache: {}
    }),
    computed: {
        ...mapGetters('reportMappa', ['segnalazioniGeojson']),
        ...mapState('reportFiltriSegnalazione', ['enteGestore']),
        ...mapState('modal', ['nuoveCoordinate']),
        ...mapGetters('auth', ['isAuthenticated'])
    },
    watch: {
        // quando i rilevameti vengono caricati
        segnalazioniGeojson(newValue) {
            // togliamo i rilevamenti precedenti
            this.vectorLayerRilevamenti.getSource().clear()
            // leggiamo i rilevamenti
            this.vectorLayerRilevamenti.getSource().addFeatures(OPEN_LAYER_GEOJSON_FORMAT.readFeatures(newValue))
        },
        // quando cambia l'indirizzo autocompletato, abbiamo nuove coordinate in cui andare
        nuoveCoordinate(newValue) {
            // se abbiamo le coordinate
            // ci spostiamo con un'animazione
            this.map.getView().animate({
                center: fromLonLat(newValue),
                zoom: 18,
                duration: 1000
            })
        },
        // === aggiorniamo le segnalazioni quando cambiano i filtri ===
        enteGestore(newValue) {
            this.caricaSegnalazioni({ light: true })
        }
    },
    methods: {
        ...mapActions('modal', ['showModal']),
        ...mapActions('reportMappa', ['cambiaSegnalazioneMostrata', 'caricaSegnalazioni']),
        ...mapMutations('reportMappa', ['SET_CENTRO_MAPPA'])
    },
    mounted() {
        // caichiamo i vettori layer
        this.vectorLayerRilevamenti = new VectorLayer({
            source: new VectorSource({
                features: undefined
            }),
            style: (feature: any, resolution) => {
                const tipoSegnalazione = feature.get('tipoSegnalazione')
                const statoSegnalazione = feature.get('statoSegnalazione')
                // check the cache and create a new style
                // level if its not been created before.
                if (!this.styleCache[tipoSegnalazione + statoSegnalazione]) {
                    let src = null // '/report/logo.png'
                    switch (tipoSegnalazione) {
                        case TIPOLOGIA_ALTRO: // 1
                            if (statoSegnalazione !== STATO_CHIUSA) src = '/report/icons/iconaCat1_red.png'
                            else src = '/report/icons/iconaCat1_green.png'
                            break
                        case TIPOLOGIA_ANIMALI: // 2
                            if (statoSegnalazione !== STATO_CHIUSA) src = '/report/icons/iconaCat2_red.png'
                            else src = '/report/icons/iconaCat2_green.png'
                            break
                        case TIPOLOGIA_ACQUEDOTTO_E_FOGNATURE: // 3
                            if (statoSegnalazione !== STATO_CHIUSA) src = '/report/icons/iconaCat3_red.png'
                            else src = '/report/icons/iconaCat3_green.png'
                            break
                        case TIPOLOGIA_ARREDO_URBANO: // 4
                            if (statoSegnalazione !== STATO_CHIUSA) src = '/report/icons/iconaCat1_red.png'
                            else src = '/report/icons/iconaCat1_green.png'
                            break
                        case TIPOLOGIA_BUCHE: // 5
                            if (statoSegnalazione !== STATO_CHIUSA) src = '/report/icons/iconaCat7_red.png'
                            else src = '/report/icons/iconaCat7_green.png'
                            break
                        case TIPOLOGIA_CARTELLONISTICA_PUBBLICITARIA: // 6
                            if (statoSegnalazione !== STATO_CHIUSA) src = '/report/icons/iconaCat1_red.png'
                            else src = '/report/icons/iconaCat1_green.png'
                            break
                        case TIPOLOGIA_DANNI_ESTESI_AL_MANTO: // 7
                            if (statoSegnalazione !== STATO_CHIUSA) src = '/report/icons/iconaCat6_red.png'
                            else src = '/report/icons/iconaCat6_green.png'
                            break
                        case TIPOLOGIA_ILLUMINAZIONE_E_SEMAFORI: // 8
                            if (statoSegnalazione !== STATO_CHIUSA) src = '/report/icons/iconaCat4_red.png'
                            else src = '/report/icons/iconaCat4_green.png'
                            break
                        case TIPOLOGIA_MARCIAPIEDE: // 9
                            if (statoSegnalazione !== STATO_CHIUSA) src = '/report/icons/iconaCat10_red.png'
                            else src = '/report/icons/iconaCat10_green.png'
                            break
                        case TIPOLOGIA_SEGNALETICA_E_VIABILITA: // 10
                            if (statoSegnalazione !== STATO_CHIUSA) src = '/report/icons/iconaCat9_red.png'
                            else src = '/report/icons/iconaCat9_green.png'
                            break
                        case TIPOLOGIA_RIFIUTI: // 11
                            if (statoSegnalazione !== STATO_CHIUSA) src = '/report/icons/iconaCat5_red.png'
                            else src = '/report/icons/iconaCat5_green.png'
                            break
                        case TIPOLOGIA_VERDE: // 12
                            if (statoSegnalazione !== STATO_CHIUSA) src = '/report/icons/iconaCat8_red.png'
                            else src = '/report/icons/iconaCat8_green.png'
                            break
                    }

                    this.styleCache[tipoSegnalazione + statoSegnalazione] = new Style({
                        image: new Icon(({
                            scale: 1,
                            src: src
                        }))
                    })
                }
                // at this point, the style for the current level is in the cache
                // so return it (as an array!)
                return [this.styleCache[tipoSegnalazione + statoSegnalazione]]
            }
        })
        // carichiamo la mappa
        this.map = new Map({
            target: 'map',
            controls: [],
            layers: [
                // open street map
                new TileLayer({
                    source: new OSM(),
                    preload: Infinity
                })
            ],
            // ci posizioniamo su casteldelci
            view: new View({
                center: fromLonLat([coordinateIniziali[0], coordinateIniziali[1]]),
                zoom: zoomIniziale
            })
        })

        // aggiugiamo il rilevamento alla mappa
        this.map.addLayer(this.vectorLayerRilevamenti)

        // display popup on click
        this.map.on('singleclick', (evt: any) => {
            if (!this.isAuthenticated)
                this.showModal('login')
            else {
                // il rilevamento cliccato
                const feature = this.map.forEachFeatureAtPixel(evt.pixel, (featureAtPixel: any, layer: any) => featureAtPixel)
                // se effettivamente abbiamo cliccato un rilevamento
                if (feature) {
                    const id = feature.get('id')
                    this.map.getView().animate({
                        center: evt.coordinate,
                        duration: 1000
                    })
                    // mostriamo il rilevamento
                    this.cambiaSegnalazioneMostrata(id)
                    this.showModal('report-info-rilevamento')
                } else {
                    // se abbiamo cliccato semplicemente sulla mappa
                    // settiamo il centro
                    this.SET_CENTRO_MAPPA(transform(evt.coordinate, 'EPSG:3857', 'EPSG:4326'))
                    // animiamo lo spostamento
                    this.map.getView().animate({
                        center: evt.coordinate,
                        duration: 1000
                    })
                    // dialogo per aggiungere una segnalazione
                    this.showModal('report-aggiungi-segnalazione')
                }
            }
        })

        // BUG fix
        // senza questo scazza e schiaccia la mappa all inizio
        setTimeout(() => {
            this.map.updateSize()
        }, 200)
    }
})
